import cn from 'classnames'
import { FC } from 'react'

import { Translation } from 'cng-common/features/translations'

import { ESP_REQUEST_STATUSES } from '../../../../lib/toggleEspStatusFilter'
import { TEspRequestStatus } from '../../../../model/types'
import { REQUEST_STATUS_LABEL_KEYS } from '../../helpers/requestStatusBadge'

import styles from './EspStatusFilter.module.scss'

interface IEspStatusFilterProps {
  /** Totals over all requests — they do not shrink as the filter narrows the list. */
  counts: Record<TEspRequestStatus, number>
  selected: TEspRequestStatus[]
  onToggle: (status: TEspRequestStatus) => void
}

/**
 * Status chips above the queue: a count per status that doubles as a toggle filter.
 * Several can be active at once; with none active the list is unfiltered.
 */
export const EspStatusFilter: FC<IEspStatusFilterProps> = ({ counts, selected, onToggle }) => {
  const hasSelection = selected.length > 0

  return (
    <div className={styles.root}>
      {ESP_REQUEST_STATUSES.map((status) => (
        <button
          key={status}
          type="button"
          aria-pressed={selected.includes(status)}
          // Once anything is filtered, the chips left out fade to grey — the active ones
          // keep their colour, so no extra selection marker is needed.
          className={cn(styles.chip, styles[status], {
            [styles.muted]: hasSelection && !selected.includes(status),
          })}
          onClick={() => onToggle(status)}
        >
          <span className={styles.dot} />
          <Translation text={REQUEST_STATUS_LABEL_KEYS[status]} span />
          <span className={styles.count}>{counts[status]}</span>
        </button>
      ))}
    </div>
  )
}

EspStatusFilter.displayName = 'EspStatusFilter'
